module.exports = __webpack_public_path__ + "media/vhome.6ec2dadb.mp4";